module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"annual-revenue":"Faturamento anual","placeholder":"R$ 1.234,50"},"en-US":{"annual-revenue":"Annual revenue","placeholder":"$1,234.50"}}')
  delete Component.options._Ctor
}
